var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":'#'+ _vm.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d00cfac0","hasScoped":false,"buble":{"transforms":{}}}!./resources/assets/front/js/components/vgb-icon/template.html
// module id = 192
// module chunks = 14